import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Login } from '../../interfaces/beans.interface';
import { NgForm } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { LoginService } from '../../services/login.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
// import { copyAnimationEvent } from '@angular/animations/browser/src/render/shared';
import { ActivatedRoute } from '@angular/router';
import { UsuarioService } from '../../services/Usuario.service';
import { MifielSignatureService } from '../../services/mifiel-signature.service';


class Mail {
  destinatario: string;
  cuerpo: string;
  asunto: string;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
})

export class LoginComponent {
  loginform = true;
  recoverform = false;
  opcion: string;
  usuario: Login = {
    username: null,
    password: null
  };
  messageAlert: string;
  typeAlert: string;
  rfcRecuperacion: string;

  constructor(private router: Router, private http: HttpClient,
     private loginService: LoginService, private toastr: ToastrService,
     private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService, private rutaActiva: ActivatedRoute,
    private miFielSignatureService: MifielSignatureService) {

    localStorage.clear();
    this.spinner.hide();
    //this.opcion = this.rutaActiva.snapshot.params.opcion;
    this.rutaActiva.params.subscribe(params => {
        this.opcion = params['opcion'];
      }
    );
    // this.prueba(this.opcion);
    // console.log('/****************** login constructor');
    // console.log(this.opcion);
    // console.trace();
  }

  prueba(opcion: string) {

    if (this.opcion === 'nueva') {
      console.log('-------- entro al no');

    } else {
      console.log('//////////////no entro al no');

    }
    console.trace();
  }

  login(loginForm: NgForm) {
    this.spinner.show();
    console.log("logincomponent->login")
    if (this.usuario.username.length > 4 && this.usuario.password.length > 0) {
      this.loginService.getLogin(this.usuario).subscribe(
        message => {
          if (message['httpStatus'] === 200) {
            localStorage.setItem('token', message['token']);
            localStorage.setItem('idUsuario', message['usuario']);
            localStorage.setItem('nombre', message['nombre']);
            localStorage.setItem('correo', message['correo']);
            localStorage.setItem('userTaxId', message['userTaxId']),
            console.info("Inside login-> loginForm");
            console.log(localStorage.getItem('token'));
            console.log(localStorage.getItem('nombre'));
            console.log(localStorage.getItem('correo'));
            this.miFielSignatureService.setMiFielSignature(message['mifiel'],message['active'],message['maxSignatures'],message['power']);
            console.log('Mifiel parameters:...')
            console.log(this.miFielSignatureService.getActiveUser());
            console.log(this.miFielSignatureService.getMifielEnabled());
            console.log(this.miFielSignatureService.getMaxMonthSignatures());
            console.log("power: ->");
            console.log(message['power']);
            console.log( this.miFielSignatureService.getPowersEnabled());
            console.log('end power');
            localStorage.setItem('roles', JSON.stringify(['ADMIN']));
            //this.router.navigate(['dashboard/tracer']);
            let opcion = this.opcion;
            console.log('Opcion -> ' + opcion);
            switch (opcion) {
              case 'nueva':
                console.log('entro nueva');
                this.router.navigate(['administracion/modificarContrasena/primerLogin']);
                break;
              case 'registro':
                console.log('entro registro');
                this.router.navigate(['administracion/modificarCuenta']);
                break;
              case 'copiaCertificaNueva':
                this.router.navigate(['administracion/copiaCertificada']);
                console.log('entro copiaCertificaNueva');
                break;
              case 'configuracionNotario':
                this.router.navigate(['administracion/configuracionNotario']);
                console.log('entro configuracionNotario');
                break;
              default:
                console.log('Ruta normal');
                this.router.navigate(['dashboard/tracer']);
                
                break;
            }

          /*
            if (this.opcion === 'nueva') {
              this.router.navigate(['administracion/modificarContrasena/primerLogin']);
              this.spinner.hide();
            } else {
              if (this.opcion === 'registro') {
                this.router.navigate(['administracion/modificarCuenta']);
                this.spinner.hide();
              } else {
                this.router.navigate(['dashboard/tracer']);
                this.spinner.hide();
              }
            }*/

          } else if (message['httpStatus'] === 400) {
            console.trace();
            this.showMessage('error', message['message'], message['messageDetail']);
            this.goLogin();
            this.spinner.hide();
          }
        },
        error => {
          console.trace();
          console.log('Login error:', error);
          // The HTTP interceptor will handle error notifications and logout for auth errors
          // We just need to hide the spinner here
          this.spinner.hide();
        },
        () => {
        }
      );
    } else {
      this.spinner.hide();
      this.showMessage('error', 'No ingreso la contraseña', 'Es requerida la contraseña');
    }
  }

  envioDatos(rfcUsuario: string) {
    console.log(rfcUsuario);
    rfcUsuario = rfcUsuario.toUpperCase();
    this.usuarioService.find(rfcUsuario).subscribe(
      message => {
        if (message['httpStatus'] === 200) {
          if (!message['usuarioModel']) {
            this.showMessage('warning', 'RFC Invalido', 'El RFC del usuario no existe');
          } else {
            this.envioMail( message['usuarioModel'].correo, message['usuarioModel'].nombre, message['usuarioModel'].password, rfcUsuario);
            this.spinner.hide();
          }
        } else if (message['httpStatus'] === 400) {
          this.showMessage('error', message['message'], message['messageDetail']);
          this.showMessageAlert('danger', message['messageDetail']);
        }
      },
      error => {
        console.trace();
        console.log('User lookup error:', error);
        // The HTTP interceptor will handle error notifications
        // We just need to hide the spinner here
      },
      () => {
        this.spinner.hide();
      }
    );
  }

  envioMail(correo: string, nombre: string, pass: string, rfcUsuario: string) {
    let mail: Mail = {
      destinatario: correo,
      asunto: 'Recuperación De Datos',
      cuerpo: '<h3>Hola ' + nombre + ' este mail se generó con los datos actuales de su cuenta</h3>' +
      '<p>Para poder ingresar a la aplicación ingrese los datos siguientes</p>' +
      //'<p>URL del sitio <a href="http://localhost:4200/#/login/registro">Tracer Mexico</a></p>' +
      '<p>URL del sitio <a href="http://app.tracer.mx/#/login/registro">Tracer México</a></p>' +
      '<p><b>USUARIO:</b> ' +  rfcUsuario + ' </p>' +
      '<p><b>CONTRASEÑA:</b> ' +   pass + ' </p>'
    };
    this.usuarioService.enviomail(mail).subscribe(
      message => {
        if (message['httpStatus'] === 200) {
          this.showMessage('info', message['message'], message['messageDetail']);
          this.showMessageAlert('info', message['messageDetail']);
        } else if (message['httpStatus'] === 400) {
          this.showMessage('error', message['message'], message['messageDetail']);
          this.showMessageAlert('danger', message['messageDetail']);
        }
      },
      error => {
        console.trace();
        console.log('Email sending error:', error);
        this.spinner.hide();
        // The HTTP interceptor will handle error notifications and logout for auth errors
      },
      () => {
        localStorage.clear();
        this.toLogin();
      }
    );
  }

  toLogin() {
    this.showRecoverForm();
  }

  goLogin() {
    localStorage.clear();
    this.router.navigate(['/']);
  }

  goRegistro() {
    localStorage.clear();
    this.router.navigate(['registro']);
  }

  showMessage(tipo: string, titulo: string, descripcion: string) {
    switch (tipo) {
      case 'success':
        this.toastr.success(descripcion, titulo);
        break;
      case 'error':
        this.toastr.error(descripcion, titulo);
        break;
      case 'warning':
        this.toastr.warning(descripcion, titulo);
        break;
      case 'info':
        this.toastr.info(descripcion, titulo);
        break;
    }
  }

  showRecoverForm() {
    this.loginform = !this.loginform;
    this.recoverform = !this.recoverform;
  }

  showMessageAlert(tipo: string, mensaje: string) {
    this.messageAlert = mensaje;
    this.typeAlert = tipo;
    setTimeout(() => this.messageAlert = null, 5000);
  }

}
